import { signoutFirebase } from "@mgdx-libs/firebase";
import { Dispatch } from "redux";

import { clearTokenAndState } from "./clearTokenAndState";

export const signoutAndClearToken = async (dispatch: Dispatch) => {
  await signoutFirebase();
  clearTokenAndState(dispatch);
};
